class Butterfly {
    public id: number;
    public commonName: string;
    public scientificName: string;
    public commonFamilyName: string;
    public scientificFamilyName: string;
    public commonSubfamilyName: string;
    public scientificSubfamilyName: string;
    public states: string;

    constructor(id: number, commonName: string, scientificName: string, commonFamilyName: string, scientificFamilyName: string, commonSubfamilyName: string, scientificSubfamilyName: string, states: string) {
        this.id = id;
        this.commonName = commonName;
        this.scientificName = scientificName;
        this.commonFamilyName = commonFamilyName;
        this.scientificFamilyName = scientificFamilyName;
        this.commonSubfamilyName = commonSubfamilyName;
        this.scientificSubfamilyName = scientificSubfamilyName;
        this.states = states;
    }

    getScientificName() { return this.scientificName; }
}

export default Butterfly;